import { DynamicStringSchema } from '@a2ui/web_core/v0_9';
import { z } from 'zod';

// The catalog's props for `VIQMatchingRules`, also used by the fixture tests
export const matchingRulesPropsSchema = z.object({
  label: DynamicStringSchema.describe('Label shown above the rules.').optional(),
  columns: z
    .string()
    .describe('JSON string of the inspected columns [{index, columnName, suggestedAttribute?}].')
    .optional(),
  attachmentId: z.string().describe('The attachment id of the inspected file.').optional(),
  limits: z
    .string()
    .describe('JSON string of the matching-rule limits {maxRules, maxFieldsPerRule, identifierAttributes}.')
    .optional(),
  initialView: z.enum(['simple', 'custom']).describe('The view the form opens in.').optional(),
  displayOnly: z.boolean().describe('Render the submitted rules read-only. Confirmation card only.').optional(),
  value: DynamicStringSchema.describe(
    'JSON string of the mapping {kind, attachmentId, rules, unused, identifierAttributes}. Bind to a data ' +
      'model path; init with an empty string, {kind, attachmentId, rules} for stated rules, or an earlier value to ' +
      'reopen it. A literal when displayOnly.',
  ),
});
